import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Actions from "../redux/actions";
import Constants, { LIMIT } from "../utils/Constants";
import RoutePath from "../utils/routes/RoutePath";
import NoDataFound from "./NoDataFound";
class AgentListScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    handleViewScreen = (id) => {
        localStorage.setItem("recentOpenedAgentId", String(id));
        const { isAgent } = this.props
        this.props.history.push(isAgent ? RoutePath.ADMIN_AGENT_VIEW : RoutePath.VENDOR_AGENT_VIEW);
        let params = {
            id: id,
            agent: isAgent
        }
        this.props.selectedId(params)
    }
    getVendorAgentRoleLabel = (vendorAgent) => {
        const role = vendorAgent?.srmAgentRole;
        if (role === 'head_nurse') return Constants.FILTER_HEAD_NURSE;
        if (role === 'ward_nurse') return Constants.FILTER_WARD_NURSE;
        if (role === 'nurse') return Constants.FILTER_FLOOR_NURSE;
        if (role === 'shared_portal') return Constants.FILTER_SHARED_PORTAL;
        const isInpatient = Number(vendorAgent?.isSrmIpAgent) === 1;
        const isHead = Number(vendorAgent?.isSrmServiceHead) === 1;
        if (isInpatient && isHead) return Constants.FILTER_SERVICE_HEAD;
        if (isInpatient) return Constants.FILTER_FLOOR_NURSE;
        return Constants.FILTER_REGULAR_AGENT;
    }
    canDeleteVendorAgent = (vendorAgent) => {
        if (!vendorAgent) return false;
        if (Number(vendorAgent.isSrmServiceHead) === 1) return false;
        if (vendorAgent.srmAgentRole === 'head_nurse') return false;
        return true;
    }
    render() {
        const { agentLists, editAgent, updateActive, deleteAgent, isAgent, isSrmIpVendor } = this.props
        const recentOpenedAgentId = localStorage.getItem("recentOpenedAgentId");
        return (
            <div className="admin_table">
                <div role="region" aria-label="data table" tabIndex="0" className="candidate_primary">
                    <table className="dashboard_table">
                        <thead>
                            <tr>
                                <th className="pin">{Constants.ID}</th>
                                <th>{Constants.NAME}</th>
                                {!isAgent && isSrmIpVendor ? <th>{Constants.EMPLOYEE_ID}</th> : null}
                                <th>{Constants.AGENT_TYPE}</th>
                                {!isAgent && isSrmIpVendor ? <th>{Constants.AGENT_ROLE}</th> : null}
                                {!isAgent && isSrmIpVendor ? <th>{Constants.WARD}</th> : null}
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isAgent ?
                                (agentLists?.length > 0 ?
                                    agentLists?.map((item, index) => {
                                        const isRecent = recentOpenedAgentId === String(item?.id);
                                        const isActive = Number(item?.isActive) === 1;
                                        return (
                                            <tr key={index} className={isRecent ? "recent-opened-row" : ""}>
                                                <td className="pin">{((this.props.currentPage - 1) * LIMIT) + (index + 1)}</td>
                                                <td>{item.fullName}</td>
                                                <td>{item.agentType === 1 ? Constants.SHARED : Constants.OWNED}</td>
                                                <td >
                                                    <i className="fa-solid fa-pen-to-square updateIcon edit-icon" onClick={() => editAgent(item.id)} />
                                                    <span onClick={() => updateActive(isActive ? 0 : 1, item)}>
                                                    </span>
                                                    <span onClick={() => updateActive(isActive ? 0 : 1, item)}>
                                                        <i style={{ fontSize: '23px' }} className={isActive ? "fa-solid fa-toggle-on toggle-icon ms-2 edit-icon" : "fa-solid fa-toggle-off toggle-icon ms-2 edit-icon"} />
                                                    </span>
                                                    <i className="fa-solid fa-eye ms-2 edit-icon" style={{ fontSize: '23px' }} onClick={() => this.handleViewScreen(item?.id)}></i>
                                                </td>
                                            </tr>
                                        );
                                    }) : <NoDataFound />)
                                :
                                (agentLists?.length > 0 ?
                                    agentLists?.map((item, index) => {
                                        const { User } = item || {};
                                        if (!User?.id && item?.fullName != null) {
                                            // Defensive: flat Users row (admin shape) on vendor branch
                                            const isRecent = recentOpenedAgentId === String(item?.id);
                                            const isActive = Number(item?.isActive) === 1;
                                            return (
                                                <tr key={index} className={isRecent ? "recent-opened-row" : ""}>
                                                    <td className="pin">{((this.props.currentPage - 1) * LIMIT) + (index + 1)}</td>
                                                    <td>{item.fullName}</td>
                                                    <td>{item.agentType === 1 ? Constants.SHARED : Constants.OWNED}</td>
                                                    <td >
                                                        <i className="fa-solid fa-pen-to-square updateIcon edit-icon" onClick={() => editAgent(item.id)} />
                                                        <span onClick={() => updateActive(isActive ? 0 : 1, item)}>
                                                            <i style={{ fontSize: '23px' }} className={isActive ? "fa-solid fa-toggle-on toggle-icon ms-2 edit-icon" : "fa-solid fa-toggle-off toggle-icon ms-2 edit-icon"} />
                                                        </span>
                                                        <i className="fa-solid fa-eye ms-2 edit-icon" style={{ fontSize: '23px' }} onClick={() => this.handleViewScreen(item?.id)}></i>
                                                    </td>
                                                </tr>
                                            );
                                        }
                                        const isRecent = recentOpenedAgentId === String(User?.id);
                                        const isActive = Number(item?.isActive ?? User?.isActive) === 1;
                                        const wardName = item?.SrmIpWard?.wardName
                                            || (item?.srmIpWardId ? `#${item.srmIpWardId}` : '-');
                                        const showDelete = this.canDeleteVendorAgent(item);
                                        return (
                                            <tr key={index} className={isRecent ? "recent-opened-row" : ""}>
                                                <td className="pin">{((this.props.currentPage - 1) * LIMIT) + (index + 1)}</td>
                                                <td>{User?.fullName || '-'}</td>
                                                {isSrmIpVendor ? <td>{item?.empId || '-'}</td> : null}
                                                <td>{Number(User?.agentType) === 1 ? Constants.SHARED : Constants.OWNED}</td>
                                                {isSrmIpVendor ? <td>{this.getVendorAgentRoleLabel(item)}</td> : null}
                                                {isSrmIpVendor ? <td>{wardName}</td> : null}
                                                <td >
                                                    <i className="fa-solid fa-pen-to-square updateIcon edit-icon" onClick={() => editAgent(User?.id)} title="Edit" />
                                                    <span onClick={() => updateActive(isActive ? 0 : 1, User)}>
                                                    </span>
                                                    <span onClick={() => updateActive(isActive ? 0 : 1, User)} title={isActive ? "Deactivate" : "Activate"}>
                                                        <i style={{ fontSize: '23px' }} className={isActive ? "fa-solid fa-toggle-on toggle-icon ms-2 edit-icon" : "fa-solid fa-toggle-off toggle-icon ms-2 edit-icon"} />
                                                    </span>
                                                    {showDelete && deleteAgent ? (
                                                        <i
                                                            className="fa-solid fa-trash ms-2 edit-icon"
                                                            style={{ fontSize: '20px' }}
                                                            title={Constants.DELETE_NURSE_TITLE}
                                                            onClick={() => deleteAgent(User)}
                                                        />
                                                    ) : null}
                                                    <i className="fa-solid fa-eye ms-2 edit-icon" style={{ fontSize: '23px' }} onClick={() => this.handleViewScreen(User?.id)} title="View"></i>
                                                </td>
                                            </tr>
                                        );
                                    }) : <NoDataFound />)
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}
export const mapStateToProps = (state) => {
    return {

    }
};
export default withRouter(connect(mapStateToProps, {
    selectedId: Actions.getAgentSelectedById
})(AgentListScreen));
